import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Box } from '@material-ui/core';
import styles from './AgsnWarningDialog.module.css';
import BlockIcon from '@material-ui/icons/Block';

const AgsnWarningDialog = ({ generateAgsn, handleClose, open }) => {
	return (
		<Modal open={open} onClose={handleClose}>
			<div className={styles.container} data-testid='generate-agsn-popup'>
				<div className={styles.title}>
					<span>
						{' '}
						<BlockIcon className={styles.block} />
					</span>

					<span className={styles.txt}>Warning</span>
				</div>
				<Box bgcolor="#dadada3d" marginTop="33px" height="130px">
					<p className={styles.warningText}>
						Once AgSN is generated, you will not be allowed to edit the plan for
						this date. Do you still want to generate AgSN ?
					</p>
				</Box>
				<div className={styles.bottomRow}>
					<button className={styles.cancelBt} onClick={handleClose}>
						Cancel
					</button>
					<span>
						<button
							onClick={() => {
								handleClose();
								generateAgsn();
							}}
							className={styles.submitBt}
						>
							Confirm
						</button>
					</span>
				</div>
			</div>
		</Modal>
	);
};

AgsnWarningDialog.propTypes = {
	generateAgsn: PropTypes.func.isRequired,
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
};

export default AgsnWarningDialog;
